import Box from "@storeblocks/box";
import styled from "styled-components";

export const HeaderWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-bottom: 12px;
  width: 100%;

  @media screen and (min-width: 426px) {
    padding-left: 14px;
  }

  & label {
    font-size: 18px;

    /* font-weight: 700; */
    font-weight: 600;
  }
`;

export const HeaderProductInfoRow = styled.div`
  width: 100%;
`;

export const HeaderProductInfoAndPriceRow = styled.div`
  display: flex;
  gap: var(--spacer-s);
  justify-content: space-between;
  width: 100%;
`;

export const StyledDesc = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.md};
  width: 100%;
`;

export const Title = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.md};
  width: 80%;
`;

export const IconWrapper = styled(Box)`
  align-self: flex-start;
  height: 50px;
  margin-right: 0;
  width: 50px;

  svg {
    height: 50px;
    width: 50px;
  }
`;

export const ChipStyled = styled.div`
  background: #c9e5b5;
  border-radius: var(--corner-radius-999, 999px);
  display: inline-block;
  font-size: var(--font-size-button-sm, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--font-line-height-button-sm, 18px);
  padding: 4px 8px;
`;

export const CustomerRecommendation = styled.div`
  margin-top: 16px;
  padding-right: 16px;
  text-align: left;
  width: 100%;
`;

export const CustomerRecommendationText = styled.p<{
  isExpanded: boolean;
}>`
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  -webkit-line-clamp: ${({ isExpanded }) => (isExpanded ? "unset" : "3")};
  line-height: ${({ theme }) => theme.lineHeight.md};
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  width: 100%;
`;

export const ExpandRecommendationButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  line-height: ${({ theme }) => theme.lineHeight.md};
  margin: 0;
  padding: 0;
  text-align: left;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
